import { values } from "lodash";
import { VendorService } from "../_services/vendorApi.service";

export const VedorApiAction = {
  addAPIDetails,
  addVendor,
  listVendor,
  listAPIDetails,
  addMapApi,
  listMapApiDetails,
  addApi,
  getApiConfigs,
};
function addAPIDetails(values) {
  return VendorService.addAPIDetails(values);
}
function addVendor(values) {
  return VendorService.addVendor(values);
}
function listVendor() {
  return VendorService.listVendor(values);
}
function listAPIDetails() {
  return VendorService.listAPIDetails();
}
function addMapApi(values) {
  return VendorService.addMapApi(values);
}
function listMapApiDetails() {
  return VendorService.listMapApiDetails();
}
function addApi(values) {
  return VendorService.addApi(values);
}
function getApiConfigs() {
  return VendorService.getApiConfigs();
}
